import React from 'react'
import { Banner } from './ui'
import { INVOICING_IS_PREVIEW, FIGURES_ARE_SAMPLE_DATA } from '../lib/features'

/**
 * Standing notices about the state of the system itself.
 *
 * Each one gates on its own switch in lib/features.js and renders nothing when
 * that switch is off, so removing a notice everywhere it appears is a one-word
 * change rather than a hunt through the pages.
 *
 * They are deliberately banners rather than dialogs. Someone working through a
 * day of invoices would dismiss a pop-up on reflex by the third one and stop
 * reading it; a banner that stays put keeps saying the same thing every time the
 * page is opened, which is the point.
 */

/** Shown wherever an invoice or quote is made or listed. */
export const InvoicingPreviewNotice = () =>
  !INVOICING_IS_PREVIEW ? null : (
    <div className="mb-4">
      <Banner tone="warning">
        <strong>Still being built.</strong> The invoice generator is a work in progress. Everything
        you save here is kept, and printing works, but please check the figures on a document before
        you send it to a customer, and tell us anything that needs changing.
      </Banner>
    </div>
  )

/**
 * Shown on the screens that are nothing but figures.
 *
 * Deliberately blunt about where the numbers come from. A demonstration revenue
 * figure mistaken for a real one is the most expensive misunderstanding this
 * panel could cause.
 */
export const SampleDataNotice = () =>
  !FIGURES_ARE_SAMPLE_DATA ? null : (
    <div className="mb-4">
      <Banner tone="info">
        <strong>Sample figures.</strong> The sales, revenue, orders and visitor numbers on this
        screen are demonstration data, put in while the system is being set up. They are not real
        Coquis trading figures. Once the shop is taking live orders these become the real thing.
      </Banner>
    </div>
  )
